import React, { useContext } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import clsx from 'clsx';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import { Header } from './Header';
import AlertResultsList from './AlertResultsList';
import { AlertResultsFilters } from './AlertResultsFilters/AlertResultsFilters';
import useAlertResultsFiltersFetch from './hooks/useAlertResultsFiltersFetch';
import { FiltersContext } from './AlertResultsFilters/FiltersContext';
import styles from './AlertResults.module.less';

type PropsParams = {
  alertId?: string;
  alertDate?: string;
};

export const AlertResults = () => {
  const { user } = useAppStateContext();
  const params = useParams<PropsParams>();
  const { collapsed } = useContext(FiltersContext);
  const {
    alerts,
    sourceSites,
    insertionDates,
    clientRegions,
    competitorSellers,
    competitorFulfillers,
    competitorSites,
  } = useAlertResultsFiltersFetch();

  if (user && !user.appPermissions['enable_product_alert']) {
    return <Redirect to="/" />;
  }

  return (
    <div className={styles.page}>
      <div className={clsx(styles.content, collapsed && styles.collapsed)}>
        <Header
          alertId={params.alertId}
          alertDate={params.alertDate}
          filters={{ alerts, sourceSites, insertionDates }}
        />
        <AlertResultsList alertId={params.alertId} />
      </div>
      <AlertResultsFilters
        hidden={collapsed}
        filters={{ clientRegions, competitorSellers, competitorFulfillers, competitorSites }}
      />
    </div>
  );
};
